import {HostInfo} from './HostInfo';
import {PickPartial} from '../../types';

export interface SessionRequest extends HostInfo {
  ModuleId: _Module;
}


export type SessionRequest_Create =
  PickPartial<
    SessionRequest,

    // These properties are just optional in general
    'PatientAge' |
    'PatientBirthSex' |
    'HccDefaultDisplay' |

    // These properties are not required to be filled in because our server and/or
    // the client that is used in the iframe can determine proper defaults.
    // But I guess if we do want to start determining these values on this client, then we can change this.
    'ClientApp' |
    'ClientAppVersion' |
    'SiteExternalId' |
    'UserExternalId' |
    'AllowedHostUrl'
  >;

export enum _Module {
  ImoProblemSearch = 'ImoProblemSearch',
}
